'use client'

import * as React from 'react'

export const SiteFooter = ({ children }: { children: React.ReactNode }) => {
  return (
    <footer className="border-border bg-background text-muted-foreground border-t py-4 text-center text-sm">
      {children}
    </footer>
  )
}
